export const GTM_EVENTS = {
  PAGE_VIEW: 'pageview',
  DOWNLOAD: 'download',
  CONTACT_CTA: 'contact_cta',
  JOIN_US_CTA: 'join_us_cta',
  CONTACT_FORM: 'contact_form',
  SEARCH_SUCCESSFUL: 'search_successful',
  SEARCH_NO_RESULT: 'search_whitout_result',
} as const
